<template>
  <div class="main qa">
    <div class="header center">
      <img src="@/assets/img/start-earth.png" alt="Earth" />
    </div>
    <div class="content">
      <div class="text ">
        <h1>QA TOOLS: {{ showQa }}</h1>
        <label class="switch">
          <input type="checkbox" v-model="$store.state.qa" @click="qaToggle" />
          <span class="slider round"></span>
        </label>
        <p class="fontMono"></p>
      </div>
      <router-link class="button" to="/game">Back to the game</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "QA",
  computed: {
    showQa: function() {
      return this.$store.state.qa ? "On" : "Off";
    },
  },

  methods: {
    qaToggle: function() {
      console.log("click");
      this.$store.commit("setQa", !this.$store.state.qa);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.qa {
  background: #000;
  color: #fff;
  display: flex;
  flex-direction: column;
  min-width: 360px;

  .content {
    margin: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // flex-grow: 1;
    .text {
      margin-bottom: 24px;
    }
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 80px;
    height: 34px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: $blue;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px$blue;
  }

  input:checked + .slider:before {
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
}
</style>
